import KeyboardDoubleArrowDown from '@mui/icons-material/KeyboardDoubleArrowDown'
import KeyboardDoubleArrowUp from '@mui/icons-material/KeyboardDoubleArrowUp'
import { Button, IconButton } from '@mui/material'
import React from 'react'
import { eachDeep } from "deepdash-es/standalone";

function ExpandCollapseIbData({data,setExpandActions,tab}) {
    
    const getAllParentNode = (data) =>{
     const parentNodes = {}
     eachDeep(data,(obj) => {
        if(obj?.key && obj?.children?.length){
            parentNodes[obj.nodeId] = obj?.key;
        }
     })
     return parentNodes;
    }

    const handleExpand = () => {
     const parentNodeArray = getAllParentNode(data)
     setExpandActions({tab:tab,keys:parentNodeArray})
    }

    const handleCollapse = () => {
        setExpandActions({tab:tab,keys:[]})
    }
    return (
        <div style={{ display: 'flex', gap: '0px' }}>
          <IconButton onClick={handleExpand} size='small' style={{ margin: '0' }}>
            <KeyboardDoubleArrowDown fontSize='small' />
          </IconButton>
          <IconButton onClick={handleCollapse} size='small' style={{ margin: '0' }}>
            <KeyboardDoubleArrowUp fontSize='small' />
          </IconButton>
        </div>
      );
      
}

export default ExpandCollapseIbData